import React, { useState } from 'react';

import { useFormikContext } from 'formik';

import { CellSummaryAnalysisFormValues } from '@components/experiments/analyses/AnalysisFormTypes';
import CellGroups from '@components/experiments/plotDisplay/fields/CellGroups';
import PreviewGroups from '@components/experiments/plotDisplay/groups/PreviewGroups';

import { useExperimentAnnotationContext } from '@contexts/ExperimentAnnotationContext';

import { AnalysisParameters, CellSummaryAnalysisParameters } from '@models/AnalysisParameters';
import Experiment from '@models/Experiment';
import Plot from '@models/Plot';

type Props = {
    plot: Plot;
    analysisParameters: AnalysisParameters | null;
    experiment: Experiment;
};
const CellSummaryAnalysisFormFields = ({ experiment, plot, analysisParameters }: Props) => {
    const { values, setFieldValue } = useFormikContext<CellSummaryAnalysisFormValues>();
    const [splitByCluster, setSplitByCluster] = useState(Boolean(values?.annotation_set_id) ?? false);

    const { annotationSets } = useExperimentAnnotationContext();
    const typedParameters = analysisParameters as CellSummaryAnalysisParameters;
    const isCleanedWorkflow = experiment?.is_cleaned_workflow ?? false;

    return (
        <div className="space-y-8">
            <div>
                <h4 className="mb-2 text-lg font-semibold tracking-tight text-dark">Define groups</h4>
                <CellGroups
                    experiment={experiment}
                    plot={plot}
                    analysisParameters={typedParameters}
                    annotationSets={annotationSets}
                    isCleanedWorkflow={isCleanedWorkflow}
                >
                    <CellGroups.Description />
                    <CellGroups.GroupByClusterField
                        checked={splitByCluster}
                        onChange={(e) => {
                            setSplitByCluster((prev) => !prev);
                            if (!e.target.checked) {
                                setFieldValue('annotation_set_id', undefined);
                            }
                        }}
                    />
                    {splitByCluster && (
                        <CellGroups.AnnotationSetField
                            value={values.annotation_set_id}
                            onChange={(e) => setFieldValue('annotation_set_id', e.target.value)}
                        />
                    )}
                    <CellGroups.VariablesField />
                    <CellGroups.LatentVariablesField />
                </CellGroups>
            </div>
            <PreviewGroups
                experiment={experiment}
                plot={plot}
                annotation_set_id={values.annotation_set_id}
                latent_variable_id={values.latent_variable_id}
                variable_ids={values.variable_ids}
            />
        </div>
    );
};

export default CellSummaryAnalysisFormFields;
